import { render, staticRenderFns } from "./groupsMembers.vue?vue&type=template&id=4460fb58&scoped=true"
import script from "./groupsMembers.vue?vue&type=script&lang=js"
export * from "./groupsMembers.vue?vue&type=script&lang=js"
import style0 from "./groupsMembers.vue?vue&type=style&index=0&id=4460fb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460fb58",
  null
  
)

export default component.exports